import { createClient, type SupabaseClient } from "@supabase/supabase-js";
import type { Database } from "@conlit/shared/database";

let client: SupabaseClient<Database> | null | undefined;
export function getSupabaseClient(): SupabaseClient<Database> | null {
  if (client !== undefined) return client;
  const url = import.meta.env.VITE_SUPABASE_URL;
  const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;
  client =
    url && anonKey
      ? createClient<Database>(url, anonKey, {
          auth: { persistSession: true, autoRefreshToken: true },
        })
      : null;
  return client;
}
